export const getToken = () => {
  try {
    const jwt = localStorage.getItem('okta-token-storage') as string;
    if (jwt !== null) {
      const tokenObj = JSON.parse(jwt);
      const token = tokenObj.accessToken.accessToken;
      // console.log('Token from getToken', token);
      return token;
    }
  } catch (error) {
    console.log('Token not found', error);
  }
};
